type LogoSize = 'md' | 'lg';

interface LogoLockupProps {
  size?: LogoSize;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Text-only stacked brand lockup:
 *
 *   StartupScore
 *        ● L I V E
 *
 * "LIVE" row sits directly below "Score", right-aligned to its trailing edge.
 * Pulse animation via .live-pulse-ring in index.css.
 */
export function LogoLockup({ size = 'md', className, style }: LogoLockupProps) {
  const namePx  = size === 'lg' ? 26 : 20;
  const liveLpx = size === 'lg' ? 12 : 10;
  const dotPx   = size === 'lg' ? 6  : 5;

  return (
    <span
      style={{ display: 'inline-flex', alignItems: 'center', gap: 0, flexShrink: 0, ...style }}
      className={className}
    >
      {/* ── Text block: two stacked rows ── */}
      <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0, lineHeight: 1 }}>

        {/* Row 1 — "StartupScore" */}
        <span style={{ display: 'inline-flex', alignItems: 'baseline' }}>
          <span
            className="logo-name-text"
            style={{ color: '#fff', fontWeight: 900, fontSize: namePx, letterSpacing: '-0.03em' }}
          >Startup</span>
          <span
            className="logo-name-text"
            style={{ color: '#f97316', fontWeight: 900, fontSize: namePx, letterSpacing: '-0.03em' }}
          >Score</span>
        </span>

        {/* Row 2 — ● LIVE, right-aligned to trailing edge of Row 1 */}
        <span style={{ alignSelf: 'flex-end', display: 'inline-flex', alignItems: 'center', gap: 3, marginTop: 1 }}>
          {/* Dot + ripple */}
          <span style={{
            position: 'relative', display: 'inline-flex', alignItems: 'center',
            justifyContent: 'center', width: dotPx, height: dotPx, flexShrink: 0,
          }}>
            <span className="live-pulse-ring" style={{ position: 'absolute', inset: 0, borderRadius: '50%', background: '#22c55e' }} />
            <span style={{ position: 'absolute', inset: 0, borderRadius: '50%', background: '#22c55e', zIndex: 1 }} />
          </span>

          {/* "LIVE" label — hidden below 480px, dot stays */}
          <span
            className="live-badge-text logo-live-text"
            style={{ color: '#22c55e', fontSize: liveLpx, fontWeight: 800, letterSpacing: '0.15em', lineHeight: 1, textTransform: 'uppercase' }}
          >LIVE</span>
        </span>

      </span>
    </span>
  );
}
